// @flow

import React from 'react';
import { connect } from 'react-redux';
import i18n from 'app/common/lib/i18n';
import { Button } from 'gestalt';
import { type Dispatch } from 'redux';
import { type State as ReduxState } from 'app/common/redux/reducers/types';
import { follow, unfollow } from 'app/common/redux/actions/topic/follow';

type ReduxDispatchProps = {|
  follow: (id: string, showTooltip?: boolean) => void,
  unfollow: (id: string) => void,
|};

type ReduxStateProps = {|
  isFollowed: boolean,
|};

type OwnProps = {|
  fullWidth?: boolean,
  isFollowed: boolean,
  onFollow?: (id: string) => void,
  onUnFollow?: (id: string) => void,
  primaryAction?: boolean,
  topicId: string,
|};

type Props = {|
  ...OwnProps,
  ...ReduxStateProps,
  ...ReduxDispatchProps,
|};

export function FollowButton({
  follow,
  fullWidth,
  isFollowed,
  topicId,
  unfollow,
  primaryAction = false,
  onFollow = () => {},
  onUnFollow = () => {},
}: Props) {
  const handleFollow = () => {
    if (isFollowed) {
      onUnFollow(topicId);
      unfollow(topicId);
    } else {
      onFollow(topicId);
      follow(topicId, primaryAction);
    }
  };

  return (
    <Button
      color={isFollowed ? 'gray' : 'red'}
      inline={!fullWidth}
      onClick={handleFollow}
      text={
        isFollowed
          ? i18n._('Following', 'Button text to display for unfollowing an interest')
          : i18n._('Follow', 'Button text to display for following an interest')
      }
      size="md"
    />
  );
}

function mapStateToProps(
  { topics }: ReduxState,
  { isFollowed, topicId }: OwnProps,
): ReduxStateProps {
  const topic = topics[topicId];

  return {
    isFollowed: topic ? Boolean(topic.is_followed) : isFollowed,
  };
}

function mapDispatchToProps(dispatch: Dispatch<any>): ReduxDispatchProps {
  return {
    follow: (id, showTooltip) => dispatch(follow(id, showTooltip)),
    unfollow: (id) => dispatch(unfollow(id)),
  };
}

export default connect<Props, OwnProps, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps,
)(FollowButton);
